export default __webpack_public_path__ + "static/media/259.a18e1e57.jpg";